import { NgModule } from '@angular/core';
import { SlimScrollDirective } from '../directives/slimscroll.directive';

@NgModule({
  declarations: [
    SlimScrollDirective
  ],
  exports: [
    SlimScrollDirective
  ]
})
export class NgSlimScrollModule { }



// WEBPACK FOOTER //
// ./~/ngx-slimscroll/src/ngx-slimscroll/module/ngx-slimscroll.module.ts